import { createContext, useContext } from 'react'

import { CompanySettingsMap } from '@shared-types/settings/index'
import { Nullable } from '@shared-types/util'

export const CompanySettingsContext = createContext<Nullable<CompanySettingsMap>>(null)

export const useCurrentUserCompanySettings = (): Nullable<CompanySettingsMap> =>
  useContext(CompanySettingsContext)

export const useCurrentUserCompanySetting = <TKey extends keyof CompanySettingsMap>(
  settingName: TKey
): Nullable<CompanySettingsMap[TKey]> => useContext(CompanySettingsContext)?.[settingName] ?? null
